/*global $ */
$(function() {
   $("#installation_status").change(function(){
     window.location = "/admin/apps/?status=" + $(this).val();
   });
});
